/*nv - null value*/
export function nv(data: string |number | null | undefined): string {
    return data?.toString() ?? '-';
}

export function iri(resourceName: string, id: number|string):string {
    return `${process.env.REACT_APP_BASE_API_URL}/${resourceName}/${id}`;
}